var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#CD2553",
    fillRule: "evenodd",
    d: "M10 2.293a7.708 7.708 0 1 0 0 15.417 7.708 7.708 0 0 0 0-15.417ZM1.04 10.001a8.958 8.958 0 1 1 17.917 0 8.958 8.958 0 0 1-17.917 0Zm5.335-3.626a.625.625 0 0 1 .884 0L10 9.116l2.741-2.741a.625.625 0 1 1 .884.884L10.884 10l2.741 2.741a.625.625 0 1 1-.884.884L10 10.884l-2.741 2.741a.625.625 0 1 1-.884-.884L9.116 10 6.375 7.259a.625.625 0 0 1 0-.884Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossCircle);
export default __webpack_public_path__ + "static/media/cross-circle.ac3071c9a1b61f8ba745eef55e347150.svg";
export { ForwardRef as ReactComponent };